<template>
  <p :class="wrapperClass ? wrapperClass : 'a-input-wrapper-column'">
    <label
      v-if="label"
      :for="$attrs.name"
      class="align-items-baseline display-flex-row"
    >
      {{ label }}
      <a
        class="clear-datepicker margin-left-auto"
        href="#"
        @click.prevent="clearValue"
      >
        x
      </a>
    </label>
    <a
      v-else
      class="clear-datepicker"
      href="#"
      @click.prevent="clearValue"
    >
      x
    </a>
    <DatePicker
      :value="datePicked"
      v-bind="$attrs"
      :disabled-dates="disabledDatesPicked"
      :input-class="inputError ? `a-input-primary a-input-danger ${inputClass}` : `a-input-primary ${inputClass}`"
      spellcheck="false"
      @input="updateValue"
    >
    </DatePicker>
    <small
      v-if="!inputError && message"
      class="font-weight-light"
    >
      <i>{{ message }}</i>
    </small>
    <small
      v-if="inputError"
      class="text-color-danger"
    >
      {{ messageError }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'AtomDatePicker',
  inheritAttrs: false,

  props: {
    disabledDates: {
      type: Object,
      default: () => ({ to: null })
    },
    inputClass: {
      type: String,
      default: ''
    },
    inputError: Boolean,
    label: String,
    message: String,
    messageError: String,
    value: {
      type: String,
      default: null
    },
    wrapperClass: String
  },

  data () {
    return {
      datePicked: null,
      disabledDatesPicked: {
        to: null
      }
    }
  },

  watch: {
    disabledDates: {
      handler () {
        this.disabledDatesPicked = this.disabledDates.to !== '' && this.disabledDates.to !== null
          ? { to: this.$moment(this.disabledDates.to, 'YYYY-MM-DD').toDate() }
          : { to: null }
      },

      inmediate: true
    },

    value: {
      handler () {
        this.datePicked = this.value !== '' && this.value !== null
          ? this.$moment(this.value, 'YYYY-MM-DD').toDate()
          : null
      },

      inmediate: true
    }
  },

  methods: {
    clearValue () {
      this.datePicked = null
      this.$emit('input', '')
    },

    updateValue (date) {
      this.datePicked = date
      date !== null
        ? this.$emit('input', this.$moment(date).format('YYYY-MM-DD'))
        : this.$emit('input', '')
    }
  }
}
</script>
